var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralSettingsNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.516167,
    y: -0.516167,
    width: 36.9677,
    height: 36.9677,
    rx: 6.48383,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 36.9677 36.9677)",
    fill: "#3772FF",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.516167,
    y: -0.516167,
    width: 36.9677,
    height: 36.9677,
    rx: 6.48383,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 36.9677 36.9677)",
    stroke: "white",
    strokeWidth: 1.03233
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1423 24.0003C14.4855 23.0293 15.4116 22.3337 16.5001 22.3337C17.5886 22.3337 18.5147 23.0293 18.8578 24.0003H27.3334V25.667H18.8578C18.5147 26.638 17.5886 27.3337 16.5001 27.3337C15.4116 27.3337 14.4855 26.638 14.1423 25.667H10.6667V24.0003H14.1423ZM19.1423 18.167C19.4855 17.196 20.4116 16.5003 21.5001 16.5003C22.5886 16.5003 23.5147 17.196 23.8578 18.167H27.3334V19.8337H23.8578C23.5147 20.8047 22.5886 21.5003 21.5001 21.5003C20.4116 21.5003 19.4855 20.8047 19.1423 19.8337H10.6667V18.167H19.1423ZM14.1423 12.3337C14.4855 11.3627 15.4116 10.667 16.5001 10.667C17.5886 10.667 18.5147 11.3627 18.8578 12.3337H27.3334V14.0003H18.8578C18.5147 14.9713 17.5886 15.667 16.5001 15.667C15.4116 15.667 14.4855 14.9713 14.1423 14.0003H10.6667V12.3337H14.1423ZM16.5001 14.0003C16.9603 14.0003 17.3334 13.6272 17.3334 13.167C17.3334 12.7068 16.9603 12.3337 16.5001 12.3337C16.0398 12.3337 15.6667 12.7068 15.6667 13.167C15.6667 13.6272 16.0398 14.0003 16.5001 14.0003ZM21.5001 19.8337C21.9603 19.8337 22.3334 19.4606 22.3334 19.0003C22.3334 18.5401 21.9603 18.167 21.5001 18.167C21.0398 18.167 20.6667 18.5401 20.6667 19.0003C20.6667 19.4606 21.0398 19.8337 21.5001 19.8337ZM16.5001 25.667C16.9603 25.667 17.3334 25.2939 17.3334 24.8337C17.3334 24.3734 16.9603 24.0003 16.5001 24.0003C16.0398 24.0003 15.6667 24.3734 15.6667 24.8337C15.6667 25.2939 16.0398 25.667 16.5001 25.667Z",
    fill: "#3772FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSettingsNewIcon);
export default __webpack_public_path__ + "static/media/generalSettingsNewIcon.9b26a080.svg";
export { ForwardRef as ReactComponent };